// extracted by mini-css-extract-plugin
module.exports = {"preloader":"styles_preloader__i7EFJ","active":"styles_active__1w6op","message":"styles_message__3oaI7"};